import dayjs from 'dayjs';

import ImageCacheWorker from '@/worker/image-cache.worker.js';
// 正则表达式
export const phoneReg = /^1[3-9]\d{9}$/;

export const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/gi;
export const codeReg = /^[a-zA-Z0-9]+$/gi;
export const passwordReg =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>/?])[a-zA-Z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>/?]{8,16}$/gi;

export const contentClssName = `
        xxs:pl-[120]
        xs:pl-[120]
        sm:pl-[120]
        md:pl-[120]
        lg:pl-[130]
        xl:pl-[150]
        2xl:pl-[150]

`;

export const isBrowser = () => {
    return typeof window !== 'undefined';
};

// 校验函数
export const isPhoneNumber = (phone) => {
    // 先去除首尾空格
    const val = String(phone).trim();
    return phoneReg.test(val);
};

// const string = '\u5f6d\u535a\u5546\u54c1\u6307\u6570'

// const unicodeArray = ['\u5f6d', '\u535a', '\u5546', '\u54c1', '\u6307', '\u6570'];

// const parsedString = unicodeArray.map(
//     (code) => {

//         return String.fromCharCode(
//             parseInt(
//                 code.replace('\\u', ''),
//                 16)
//         )
//     }
// ).join('');

export const getQuarter = (date, join = '') => {
    const month = dayjs(date).month() + 1; // 获取月份，+1是为了从1开始计数
    return dayjs(date).format('YYYY') + join + 'Q' + Math.ceil(month / 3); // 通过月份除以3并向上取整来确定季度
};

export const codeToChinese = (string: string) => {
    const unicodeArray = string.split('\\u').slice(1);
    return unicodeArray
        .map((code) => {
            return String.fromCharCode(parseInt(code, 16));
        })
        .join('');
};

export const getWinWH = () => {
    let viewportWidth = 0;
    let viewportHeight = 0;
    if (process.browser && window) {
        viewportWidth = window.innerWidth || document.documentElement.clientWidth;
        viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    }

    return {
        width: viewportWidth,
        height: viewportHeight,
    };
};

export const loadImg = (src: string) => {
    return new Promise((reslove, reject) => {
        const image = new Image();
        image.src = src;
        if (image.complete) {
            reslove(image);
        } else {
            image.onload = () => {
                reslove(image);
            };
        }
    });
};

export const maskEmail = (email: string) => {
    // 匹配邮箱前缀和域名（兼容各种长度）
    const reg = /^(.+)@(.+)$/;
    if (reg.test(email)) {
        return email.replace(reg, (match, prefix, domain) => {
            if (prefix.length <= 1) {
                // 前缀只有1个字符：直接显示该字符 + *@
                return `${prefix}*@${domain}`;
            } else {
                // 前缀长度≥2：保留第一个字符，其余用*替换（长度保持一致）
                const maskedPrefix = prefix[0] + '*'.repeat(prefix.length - 1);
                return `${maskedPrefix}@${domain}`;
            }
        });
    }
    // 非邮箱格式返回原字符串
    return email;
};

export const maskAnyPhone = (phone = '') => {
    // 移除所有非数字字符
    const pureNumber = phone.toString().replace(/\D/g, '');
    let starsLength;
    let sliceLength;

    // 对于太短的号码（小于4位）直接返回原号码或提示
    if (pureNumber.length < 4) {
        // return pureNumber // 或返回 '号码过短'
        starsLength = pureNumber.length - 2;

        sliceLength = 1;
    } else {
        starsLength = pureNumber.length - 4;
        sliceLength = 2;
    }

    const stars = '*'.repeat(starsLength);

    return pureNumber.slice(0, sliceLength) + stars + pureNumber.slice(-sliceLength);
};

// 将Buffer(Uint8Array)转换为Base64
export const bufferToBase64 = (buffer) => {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;

    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }

    return 'data:image/jpeg;base64,' + window.btoa(binary);
};

export const removeLine = (string: string) => {
    return string.replace(/\/{2,}/g, '/').trim();
};

// 1. 封装函数：生成min到max之间的随机整数（包含min和max）
export const getRandomInt = (min = 15, max = 30) => {
    // 核心公式：Math.floor(Math.random() * (最大值-最小值+1)) + 最小值
    // 30-15+1=16，确保随机数范围是0-15，加15后就是15-30
    return Math.floor(Math.random() * (max - min + 1)) + min;
};

// 👇 你提供的计算总偏移的函数
export const getOffset = (element) => {
    let offsetTop = 0;
    let offsetLeft = 0;
    while (element) {
        offsetTop += element.offsetTop;
        offsetLeft += element.offsetLeft;
        element = element.offsetParent;
    }

    return {
        top: offsetTop,
        left: offsetLeft,
    };
};

export const getImageCache = () => {
    const imageCacheWorker = new ImageCacheWorker();

    const $getImageCache = ({ cacheName, imageUrl }) => {
        imageCacheWorker.postMessage({ url: imageUrl, cacheName: cacheName });

        return new Promise((resolve) => {
            imageCacheWorker.onmessage = async (e) => {
                const { status, message, url } = e.data;

                try {
                    if (e.data.status === 'cached' || e.data.status === 'cache-hit') {
                        // 从缓存拿图片
                        const cache = await caches.open(cacheName);
                        const res = await cache.match(e.data.url);
                        const blob = await res.blob();
                        const blobUrl = URL.createObjectURL(blob);

                        resolve(blobUrl);

                        // if (e.data.status === 'cached') {

                        //     resolve(url);
                        // } else if (e.data.status === 'cache-hit') {
                        //     resolve(url);
                    } else if (e.data.status === 'error') {
                        resolve(imageUrl);
                        console.error('Error:', e.data.message);
                    }
                } catch (err) {
                    resolve(imageUrl);
                }
            };
        });
    };

    $getImageCache.terminate = () => {
        imageCacheWorker.terminate();
    };
    $getImageCache.imageCacheWorker = imageCacheWorker;

    return $getImageCache;
};
